const signs = [
  {
    icon: 'ri-emotion-sad-line',
    title: 'Падение продаж или стагнация',
    description: 'Отдел продаж не выполняет план, конверсия падает, менеджеры теряют клиентов на одних и тех же этапах воронки. Это сигнал, что сотрудникам не хватает навыков.',
  },
  {
    icon: 'ri-user-unfollow-line',
    title: 'Высокая текучесть кадров',
    description: 'Сотрудники уходят, не проработав года. Одна из главных причин — отсутствие перспектив развития. Обучение снижает текучесть на 30-40%.',
  },
  {
    icon: 'ri-temp-hot-line',
    title: 'Конфликты и низкая коммуникация',
    description: 'Постоянные недопонимания между отделами, срывы сроков из-за плохой координации, напряженная атмосфера в коллективе.',
  },
  {
    icon: 'ri-shield-cross-line',
    title: 'Руководители не справляются',
    description: 'Хороших специалистов повысили до руководителей, но они не умеют управлять. Результат — демотивация команды и падение показателей.',
  },
  {
    icon: 'ri-user-add-line',
    title: 'Новички долго входят в должность',
    description: 'Новые сотрудники выходят на плановые показатели за 3-6 месяцев вместо 1-2. Нет системы адаптации и передачи знаний.',
  },
  {
    icon: 'ri-pie-chart-line',
    title: 'Нет измеримых результатов обучения',
    description: 'Тренинги проводятся, но непонятно, приносят ли они пользу. Нет системы оценки эффективности и отслеживания прогресса.',
  },
  {
    icon: 'ri-git-repository-line',
    title: 'Знания не накапливаются',
    description: 'Опытные сотрудники уходят и уносят экспертизу с собой. Компания каждый раз начинает с нуля вместо создания базы знаний.',
  },
  {
    icon: 'ri-speed-mini-line',
    title: 'Конкуренты обходят',
    description: 'Рынок меняется, а компания не успевает адаптироваться. Сотрудники работают по-старому, нет инноваций и развития.',
  },
];

export default function WhenCompanyNeeds() {
  return (
    <section id="when-needed" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-6 leading-tight">
            Как понять, что компании пора инвестировать в обучение
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Существует несколько безошибочных признаков, по которым руководитель может определить: откладывать обучение дальше нельзя.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {signs.map((item) => (
            <div key={item.title} className="flex items-start gap-4 bg-white rounded-xl p-6 border border-gray-100 hover:shadow-md transition-all">
              <div className="w-12 h-12 bg-red-50 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-xl text-red-500`}></i>
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}